<ion-header>
  <div class="flex-space-between" style="align-items: center; padding: 0 10px">
    <ion-buttons>
      <ion-button (click)="dismiss()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <div style="width: 100%; padding-right: 20px">
      <h3 style="margin: 15px 0 0">
        <ion-input
          style="--padding-bottom: 0px; --padding-top: 0px"
          #nameInput
          placeholder="Untitled automation"
          [(ngModel)]="name"
        >
        </ion-input>
      </h3>
      <ion-input
        style="--padding-top: 0px; --padding-bottom: 0px; margin: 5px 0 15px; font-size: 0.8rem"
        #descriptionInput
        placeholder="Add a description"
        [(ngModel)]="description"
      >
      </ion-input>
    </div>
    <div
      style="
        font-size: 0.85rem;
        font-weight: 500;
        display: flex;
        width: 235px;
        align-items: center;
        align-content: flex-end;
        justify-content: flex-end;
        margin-top: 18px;
        margin-right: 12px;
      "
    >
      <ion-text
        (click)="isActive = false; onActiveToggleChanged()"
        [color]="isActive ? 'dark' : 'warning'"
        class="clickable"
        [ngClass]="{ 'active-toggle-label-inactive': isActive }"
        >Paused</ion-text
      >
      <ion-toggle (ionChange)="onActiveToggleChanged()" [(ngModel)]="isActive" color="success"></ion-toggle>
      <ion-text
        (click)="isActive = true; onActiveToggleChanged()"
        [color]="isActive ? 'success' : 'dark'"
        class="clickable"
        [ngClass]="{ 'active-toggle-label-inactive': !isActive }"
        >Live</ion-text
      >
    </div>
  </div>
</ion-header>

<ion-content #content>
  <div class="flexed">
    <div class="main-content">
      <div style="padding: 25px">
        <ion-card
          class="action-card"
          style="margin-right: auto; margin-left: auto; width: fit-content; min-width: 440px"
        >
          <ion-list class="no-padding transparent-bg">
            <ion-item class="box-header-item">
              <ion-label position="stacked" color="secondary" style="font-size: 0.9rem">
                <ion-icon name="flash"></ion-icon>
                Trigger
              </ion-label>
              <ion-select
                #triggerTypeInput
                placeholder="Select Trigger Type"
                [(ngModel)]="trigger.type"
                interface="popover"
                style="font-size: 1rem; padding-bottom: 10px"
              >
                <ion-select-option [value]="AUTOMATION_TRIGGER_TYPES.EVENT">Automatic</ion-select-option>
                <ion-select-option [value]="AUTOMATION_TRIGGER_TYPES.SCHEDULED">Scheduled</ion-select-option>
                <ion-select-option [value]="AUTOMATION_TRIGGER_TYPES.SLACK_REACTION">Slack Reaction</ion-select-option>
                <ion-select-option [value]="AUTOMATION_TRIGGER_TYPES.MANUAL"
                  >Manual (on button click)</ion-select-option
                >
                <ion-select-option [value]="AUTOMATION_TRIGGER_TYPES.WEBHOOK">Webhook</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-list>

          <ion-card-header [hidden]="!trigger?.type">
            <ion-spinner name="crescent" *ngIf="isInitializing"> </ion-spinner>

            <div class="flexed" style="align-items: center" [hidden]="isInitializing">
              <ion-select
                placeholder="Choose frequency"
                [(ngModel)]="cronFrequency"
                interface="popover"
                class="input-field"
                *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.SCHEDULED"
              >
                <ion-select-option *ngFor="let frequency of CRON_FREQUENCIES" [value]="frequency.value">{{
                  frequency.label
                }}</ion-select-option>
              </ion-select>
              <span
                *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.SCHEDULED && cronFrequency === 'week'"
                class="trigger-text"
                >on</span
              >
              <ion-select
                placeholder="Choose day"
                [(ngModel)]="cronDay"
                interface="popover"
                class="input-field"
                *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.SCHEDULED && cronFrequency === 'week'"
              >
                <ion-select-option *ngFor="let day of CRON_DAYS">{{ day }}</ion-select-option>
              </ion-select>
              <span *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.SCHEDULED" class="trigger-text">at</span>
              <ion-button
                color="dark"
                fill="clear"
                class="button-dark-border btn-small"
                (click)="editTime()"
                style="margin: 5px 0 0 0"
                *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.SCHEDULED"
              >
                <ion-icon name="time-outline" style="margin-right: 3px"></ion-icon>
                {{ cronTimeDisplay || 'Select a time' }}
              </ion-button>

              <ion-select
                *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.SCHEDULED"
                class="input-field"
                interface="popover"
                [(ngModel)]="timezone"
                placeholder="Select timezone"
                style="margin-left: 6px"
              >
                <ion-select-option *ngFor="let tz of timezoneOptions" [value]="tz">
                  {{ tz }}
                </ion-select-option>
              </ion-select>

              <div *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.EVENT" style="margin-left: 0" class="trigger-text">
                When:
              </div>
              <ion-select
                #triggerEventInput
                placeholder="Select Trigger Object"
                [(ngModel)]="trigger.data.objectType"
                class="input-field"
                interface="popover"
                *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.EVENT"
              >
                <ion-select-option value="conversation">Conversation</ion-select-option>
              </ion-select>
              <ion-select
                #triggerEventInput
                placeholder="Select Trigger Event"
                [(ngModel)]="trigger.data.event"
                class="input-field"
                interface="popover"
                style="margin-left: 6px"
                *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.EVENT"
              >
                <ion-select-option *ngFor="let event of getEventsForTrigger(trigger.data.objectType)" [value]="event">
                  {{ formatTriggerEvent(event) | titlecase }}
                </ion-select-option>
              </ion-select>
              <ng-container *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.SLACK_REACTION">
                <ion-list lines="none" class="no-padding">
                  <ion-chip
                    outline
                    color="dark"
                    *ngFor="let emoji of trigger.data.emojis; let i = index"
                    (click)="removeEmoji(i)"
                    style="font-size: 1.3rem"
                  >
                    <ion-label>{{ emoji }}</ion-label>
                    <ion-icon name="close-circle"></ion-icon>
                  </ion-chip>
                </ion-list>
                <ion-chip [outline]="true" color="primary" class="btn-small" (click)="openEmojiPicker()">
                  + Add
                </ion-chip>
              </ng-container>

              <ion-select
                #triggerFilterInput
                placeholder="Any update"
                [(ngModel)]="eventTriggerConfig.subEvent"
                class="input-field"
                interface="popover"
                *ngIf="triggerConfigFields[getTriggerKey()]?.subEvent"
                [compareWith]="triggerFilterCompareFn"
                style="margin-left: 6px"
              >
                <ion-select-option [value]="null"> Any update </ion-select-option>
                <ion-select-option *ngFor="let subEvent of CONVERSATION_UPDATE_SUB_EVENTS" [value]="subEvent.value">
                  {{ subEvent.label }}
                </ion-select-option>
              </ion-select>
            </div>
            <div
              *ngIf="triggerConfigFields[getTriggerKey()]?.minutes"
              [hidden]="isInitializing"
              style="margin-top: 10px"
            >
              Minutes since last reply:
              <ion-input
                [(ngModel)]="eventTriggerConfig.minutes"
                class="input-field"
                type="number"
                *ngIf="triggerConfigFields[getTriggerKey()]?.minutes"
                placeholder="60"
                min="1"
                step="1"
              ></ion-input>
            </div>
          </ion-card-header>
          <ion-card-content *ngIf="trigger.type === 'webhook'">
            <ion-card-subtitle>
              <ion-icon name="custom-webhooks"></ion-icon>
              {{ id ? 'Webhook URL:' : 'Webhook URL will be generated after saving' }}
            </ion-card-subtitle>
            <div *ngIf="id" class="webhook-url-section flex-space-between">
              <span class="code" style="font-size: 0.8rem">{{ getWebhookUrl(id) }}</span>
              <a ngxTippy data-tippy-content="Copy to clipboard" (click)="copyWebhookUrlToClipboard(id)">
                <ion-icon name="copy-outline" style="margin-left: 12px"></ion-icon>
              </a>
            </div>
          </ion-card-content>
          <div *ngIf="trigger.type === 'manual'" style="margin-top: -15px">
            <ion-card-header *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.MANUAL && inputFields?.length">
              <ion-card-subtitle>
                <ion-icon name="create-outline"></ion-icon>
                Input fields ({{ inputFields?.length ?? 0 }})
              </ion-card-subtitle>
            </ion-card-header>
            <div style="margin: 8px">
              <app-custom-fields
                [customFields]="inputFields"
                [placeholder]="'Ex: Favorite color'"
                [addCustomFieldButtonLabel]="'Add an input field'"
                [showPublicOption]="false"
                [showUserAttributeOption]="false"
                [showBranchingInput]="false"
                [showDescription]="true"
              >
              </app-custom-fields>
            </div>
          </div>
        </ion-card>
        <div
          [hidden]="
            trigger.type !== AUTOMATION_TRIGGER_TYPES.EVENT && trigger.type !== AUTOMATION_TRIGGER_TYPES.SLACK_REACTION
          "
        >
          <div class="line"></div>
          <div style="text-align: center; font-size: 0.7rem; opacity: 0.7; margin: 5px 0" [hidden]="!filters?.size">
            Continue if:
          </div>
          <ion-card class="action-card filter-card" [hidden]="!filters?.size">
            <app-filter-button
              #filterButton
              [options]="filterOptions"
              (didChange)="filtersDidChange($event)"
              [selected]="filters"
              [allowNotEqualsOperator]="true"
            ></app-filter-button>
          </ion-card>
          <div style="text-align: center" [hidden]="filters?.size">
            <a (click)="addFilter()" ngxTippy data-tippy-content="Add a filter">
              <ion-icon name="filter-outline" class="support-step-icon"> </ion-icon>
            </a>
          </div>
        </div>
        <div class="line"></div>
        <div
          style="text-align: center"
          (dragover)="onDragOver($event, 0)"
          (dragleave)="onDragOut($event)"
          [ngClass]="{ 'drag-highlight': draggingOverStepIndex === 0 && !draggingOverBranch }"
        >
          <a (click)="addStep(0)" ngxTippy data-tippy-content="Add a step">
            <ion-icon name="add" class="support-step-icon"> </ion-icon>
          </a>
        </div>
        <div
          *ngFor="let step of steps; let i = index"
          [@listAnimation]="animationStep === step ? 'active' : 'inactive'"
          class="card-container"
        >
          <div class="line"></div>
          <div>
            <app-automation-action-step
              [step]="step"
              [index]="i"
              [lookups]="lookups"
              [functionNames]="functionNames"
              [functionsVersions]="functionsVersions"
              (remove)="removeStep(i)"
              (actionDidChange)="actionDidChange(step.data.action)"
              [draggable]="true"
              (dragend)="onDragActionEnd($event, i)"
              [canDrag]="true"
            ></app-automation-action-step>

            <ng-container *ngIf="step.type === 'branches'">
              <div class="skinny-card">
                <div
                  style="border-left: 2px solid var(--ion-color-step-100); margin-left: 32px"
                  class="flexed"
                  *ngFor="let branch of step.data.branches; let b = index"
                >
                  <div
                    style="
                      width: 29px;
                      height: 46px;
                      border-radius: 0 0 0 20px;
                      border-bottom: 3px solid var(--ion-color-step-100);
                    "
                  ></div>
                  <div style="flex-grow: 1; padding-bottom: 24px">
                    <ion-card
                      class="action-card skinny-card"
                      style="margin-top: 16px"
                      [@listAnimation]="animationStep === step ? 'active' : 'inactive'"
                    >
                      <ion-list class="no-padding">
                        <ion-item>
                          <ion-label>
                            <h3 style="font-weight: 500">Condition {{ b + 1 }}</h3>
                          </ion-label>
                          <ion-button
                            (click)="removeBranch(i, b)"
                            color="dark"
                            fill="clear"
                            class="btn-small icon-button"
                            slot="end"
                            [hidden]="step.data.branches.length === 1"
                          >
                            <ion-icon name="trash"></ion-icon>
                          </ion-button>
                        </ion-item>
                      </ion-list>
                      <div style="padding: 0 10px 6px 10px">
                        <app-filter-button
                          [options]="filterOptions"
                          [selected]="branch.filters"
                          (didChange)="branchFiltersDidChange($event, branch)"
                          [allowNotEqualsOperator]="true"
                        ></app-filter-button>
                        <p
                          *ngIf="
                            step.data.branches.length > 1 &&
                            b === step.data.branches.length - 1 &&
                            !branch.filters?.size
                          "
                          style="opacity: 0.6; font-size: 0.75rem"
                        >
                          Leave filter empty to be fallback condition
                        </p>
                      </div>
                    </ion-card>
                    <ng-container *ngFor="let branchStep of branch.steps; let j = index">
                      <div [@listAnimation]="animationStep === branchStep ? 'active' : 'inactive'" class="line"></div>
                      <div [@listAnimation]="animationStep === branchStep ? 'active' : 'inactive'">
                        <app-automation-action-step
                          [step]="branchStep"
                          [index]="j"
                          [lookups]="lookups"
                          [functionNames]="functionNames"
                          [functionsVersions]="functionsVersions"
                          (remove)="removeStep(j, branch)"
                          (actionDidChange)="actionDidChange(branchStep.data.action)"
                        ></app-automation-action-step>
                      </div>
                    </ng-container>
                    <div class="line"></div>
                    <div
                      style="text-align: center"
                      (dragover)="onDragOver($event, i + 1, branch)"
                      (dragleave)="onDragOut($event)"
                      [ngClass]="{
                        'drag-highlight': draggingOverStepIndex === i + 1 && draggingOverBranch === branch
                      }"
                    >
                      <a (click)="addStep(i + 1, branch)" ngxTippy data-tippy-content="Add a step">
                        <ion-icon name="add" class="support-step-icon"> </ion-icon>
                      </a>
                    </div>
                  </div>
                </div>
                <div style="padding-left: 22px; border-left: 2px solid var(--ion-color-step-100); margin-left: 32px">
                  <ion-button
                    (click)="addBranch(i)"
                    color="dark"
                    fill="clear"
                    class="btn-small button-dark-border"
                    slot="end"
                  >
                    <ion-icon name="add"></ion-icon>
                    Add condition
                  </ion-button>
                </div>
                <div class="flexed">
                  <div
                    style="
                      margin-left: 32px;
                      margin-bottom: 12px;
                      border-bottom: 2px solid var(--ion-color-step-100);
                      width: calc(50% - 72px);
                      border-left: 2px solid var(--ion-color-step-100);
                      border-radius: 0 0 0 20px;
                      height: 20px;
                    "
                  ></div>
                  <div
                    style="
                      width: 41px;
                      height: 20px;
                      margin-top: 18px;
                      border-radius: 0 20px 0;
                      border-top: 2px solid var(--ion-color-step-100);
                      border-right: 3px solid var(--ion-color-step-100);
                    "
                  ></div>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="line"></div>
          <div
            style="text-align: center"
            (dragover)="onDragOver($event, i + 1)"
            (dragleave)="onDragOut($event)"
            [ngClass]="{ 'drag-highlight': draggingOverStepIndex === i + 1 && !draggingOverBranch }"
          >
            <a (click)="addStep(i + 1)" ngxTippy data-tippy-content="Add a step">
              <ion-icon name="add" class="support-step-icon"> </ion-icon>
            </a>
          </div>
        </div>
        <div class="line"></div>
        <div style="text-align: center">
          <ion-text color="success">
            <ion-icon name="checkmark-circle" class="support-step-icon" ngxTippy data-tippy-content="End of sequence">
            </ion-icon>
          </ion-text>
        </div>
      </div>
    </div>
    <div class="right-col hidden-sm">
      <ion-toolbar class="sticky-toolbar">
        <span
          class="tab-nav-link"
          [ngClass]="{ 'tab-nav-active': selectedTab === 'build' }"
          (click)="selectedTab = 'build'"
        >
          <ion-icon [name]="selectedTab === 'build' ? 'color-wand' : 'color-wand-outline'"></ion-icon>
          Build
        </span>
        <span
          class="tab-nav-link"
          [ngClass]="{ 'tab-nav-active': selectedTab === 'test' }"
          (click)="selectedTab = 'test'"
        >
          <ion-icon [name]="selectedTab === 'test' ? 'play' : 'play-outline'"></ion-icon>
          Test
        </span>
        <span
          class="tab-nav-link"
          [ngClass]="{ 'tab-nav-active': selectedTab === 'runs' }"
          (click)="selectedTab = 'runs'; getRunHistory()"
        >
          <ion-icon [name]="selectedTab === 'runs' ? 'time' : 'time-outline'" style="margin-right: 1px"></ion-icon>
          History
        </span>
      </ion-toolbar>

      <div [hidden]="selectedTab !== 'test'">
        <div *ngIf="!id" style="padding: 15px; opacity: 0.7">Save automation before running a test</div>
        <div *ngIf="id">
          <ion-list
            class="no-padding transparent-bg"
            *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.EVENT || trigger.type === AUTOMATION_TRIGGER_TYPES.MANUAL"
          >
            <ion-item>
              <ion-label>
                <ion-button color="dark" fill="clear" [disabled]="true" class="fake-button"> Input: </ion-button>
                <ion-button
                  (click)="chooseConversation()"
                  [color]="testObjectId ? 'light' : 'primary'"
                  [disabled]="testIsRunning"
                  *ngIf="trigger.data.objectType === 'conversation'"
                >
                  {{ testObjectId ? 'ID: ' + testObjectId : 'Choose conversation...' }}
                  <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon
                ></ion-button>
              </ion-label>
              <ion-input
                [(ngModel)]="testObjectId"
                *ngIf="trigger.data.objectType !== 'conversation'"
                placeholder="e.g. 'bdfc1253-f4dd-462d-bdfe-7996c670fcf9'"
              >
              </ion-input>
            </ion-item>
            <ion-item>
              <ion-label>
                <ion-button color="dark" fill="clear" [disabled]="true" class="fake-button"> Output: </ion-button>
                <ion-button
                  [color]="testObjectId ? 'primary' : 'light'"
                  [disabled]="!testObjectId || testIsRunning"
                  (click)="runTest()"
                >
                  {{ testIsRunning ? 'Running...' : 'Run' }}
                </ion-button>
                <ion-button color="light" *ngIf="testRunId" (click)="getTestLogs()"> Refresh logs </ion-button>
              </ion-label>
            </ion-item>
          </ion-list>
          <ion-list *ngIf="trigger.type === AUTOMATION_TRIGGER_TYPES.WEBHOOK">
            <ion-item>
              <ion-label>
                <ion-button color="dark" fill="clear" [disabled]="true" class="fake-button"> Input: </ion-button>
                <ion-label slot="end">
                  <code>{{ '{ sampleKey: "sampleValue" }' }}</code>
                </ion-label>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-button [color]="testIsRunning ? 'light' : 'primary'" [disabled]="testIsRunning" (click)="runTest()">
                {{ testIsRunning ? 'Running...' : 'Run' }}
              </ion-button>
            </ion-item>
          </ion-list>
          <ion-list lines="none">
            <ion-item *ngFor="let log of testLogs">
              <pre style="margin: 0; text-wrap: wrap">{{ log.message }}</pre>
            </ion-item>
          </ion-list>
        </div>
      </div>

      <div [hidden]="selectedTab !== 'build'">
        <div class="search-container">
          <ion-searchbar
            mode="ios"
            class="action-search-bar"
            placeholder="Search actions..."
            showCancelButton="never"
            [(ngModel)]="searchTerm"
          ></ion-searchbar>
        </div>

        <div style="padding: 5px">
          <ion-list class="no-padding">
            <ion-item
              *ngFor="let option of filteredActionOptions; let index = index"
              class="no-padding"
              button="true"
              (click)="insertStepAtIndex(steps.length, option.metadata, null, true)"
              [draggable]="true"
              (dragend)="onDragOptionEnd($event, index)"
              style="border-radius: 6px"
            >
              <ion-icon [name]="option.icon" slot="start" style="margin-right: 15px"></ion-icon>
              <ion-label text-wrap>
                <h3>{{ option.label }}</h3>
                <p>{{ option.metadata.description }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
      </div>

      <div [hidden]="selectedTab !== 'runs'" style="padding: 5px">
        <div *ngIf="!id || (!isLoadingRuns && !automationRuns?.length)" style="padding: 10px; opacity: 0.7">
          No runs yet
        </div>
        <div *ngIf="id">
          <div *ngIf="isLoadingRuns" style="padding: 10px">Loading...</div>
          <ion-list class="no-padding transparent-bg">
            <ion-item class="no-padding" *ngFor="let run of automationRuns">
              <ion-spinner
                name="crescent"
                class="automation-left-icon"
                slot="start"
                *ngIf="run.status === 'pending' || run.status === 'running'"
              ></ion-spinner>
              <ion-icon
                slot="start"
                name="checkmark-circle"
                class="automation-left-icon"
                style="color: var(--ion-color-success)"
                *ngIf="run.status === 'completed'"
              ></ion-icon>
              <ion-icon
                slot="start"
                name="close-circle"
                class="automation-left-icon"
                style="color: var(--ion-color-danger)"
                *ngIf="run.status === 'failed' || run.status === 'canceled'"
              ></ion-icon>
              <ion-label text-wrap>
                <h3>{{ run.startedAt | date: 'MMM d yyyy h:mm a' }}</h3>
                <p style="text-transform: capitalize">
                  {{ run.status }}<span *ngIf="run.status === 'running'">...</span>
                </p>
              </ion-label>
              <ion-label slot="end">
                <a (click)="viewLogsForAutomationRun(run.id)">Logs</a>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
      </div>
    </div>
  </div>
  <div style="text-align: left; padding: 20px; bottom: 0; position: fixed; pointer-events: none">
    <ion-button (click)="save()" [disabled]="isLoading" style="pointer-events: auto">
      Save
      <ion-spinner name="dots" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
    </ion-button>
    <ion-button
      color="danger"
      fill="clear"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      style="pointer-events: auto"
    >
      Delete
    </ion-button>
    <ion-button color="dark" fill="clear" [disabled]="true" style="margin-left: 10px" class="fake-button hidden-sm">
      {{ updatedAt ? 'Last updated: ' + displayDateFrom(updatedAt) : 'Not saved yet' }}
    </ion-button>
  </div>
</ion-content>
